import {createReducer} from '../utils/reducerHelper';

const initialState = {
    event: null
  };

export const TRACK_EVENT = 'TRACK_EVENT';

export function trackEvent(event, properties) {
    return {
      type: TRACK_EVENT,
      payload: {
        event,
        properties
      }
    };
  }

export default createReducer(initialState, {
    [TRACK_EVENT]: (state, payload) => {
      return Object.assign({}, state, {
        event: payload
      });
    }
  });


// WEBPACK FOOTER //
// ./src/reducers/analyticsReducer.js